module.exports = __webpack_public_path__ + "img/cu05.eea330ca.jpg";